import type { Dayjs } from 'dayjs'
import dayjs from '../../../utils/dayjs'

/**
 * Moment a new follow-up opens with: in one hour. The day and the time of the
 * form are both read from it, so after 23:00 the form proposes tomorrow at
 * 00:xx instead of today at an hour already gone.
 */
export const getDefaultKeepStart = (now: Dayjs = dayjs()): Dayjs => now.add(1, 'hour')
